/**
 * ## Waitlist Controller
 *
 * @module src/controllers/waitlist
 */

"use strict";

const component = require("../../components/component");
const layout = require("../../components/layout");
const notification = require("../../components/notification");
const block = require("../../components/block");
const func = require("../../controllers/func");
const modal = require("../../components/modal");
const print = require("../../components/print");
const location = require("../../controllers/location");
const conf = require("../../config");
const chart = require("../../controllers/chart");
const tabs = require("../../controllers/tabs");
const l = require("../../common").localization;

const partysize = () => {
  $("#btn_waiting_partysize").addClass("theme_btn_ocean_highlight");
  $("#btn_waiting_waittime").removeClass("theme_btn_ocean_highlight");
  $("#waiting_partysize").css("display", "block");
  $("#waiting_waittime").css("display", "none");
};

const waittime = () => {
  $("#btn_waiting_partysize").removeClass("theme_btn_ocean_highlight");
  $("#btn_waiting_waittime").addClass("theme_btn_ocean_highlight");
  $("#waiting_partysize").css("display", "none");
  $("#waiting_waittime").css("display", "block");
};

/** Init
 */
const init = (kd) => {
  $("#btn_waiting_partysize").off();
  $("#btn_waiting_partysize").fastClick(() => {
    partysize();
  });

  $("#btn_waiting_waittime").off();
  $("#btn_waiting_waittime").fastClick(() => {
    waittime();
  });

  $("#reservation_filter_search").on("keyup", () => {
    $("#search_box").val($("#reservation_filter_search").val());
    kd.localstore.data.filter.name = $("#search_box").val();
    kd.localstore.data.filter.time = 1;
    $("#reservation_filter_drop").val(l.translate("Show All"));
    kd.emit("activity.update", {});
  });

  $("#tab_btn_addparty, #tab_btn_addparty_wide").off();
  $("#tab_btn_addparty, #tab_btn_addparty_wide").fastClick((e) => {
    // e.stopPropagation();

    const opt = {
      width: "90%",
      type: "addparty",
      subtype: "waitlist",
      mode: "waitlist",
      h1: "Dialog Header",
      body: "This is the body text inside the dialog box",
      buttons: [
        {
          description: "cancel",
          value: "cancel...",
        },
        {
          description: "close",
          value: "close",
        },
        {
          description: "third",
          value: "close",
        },
      ],
    };

    const data = {
      kd,
      location: location.location,
    };
    modal.create(opt, data, (err, value) => {
      modal.destroy();
    });
  });

  const loc = kd.doc("location")[0];

  if (!loc.hasOwnProperty("groupCallBack") || !loc.groupCallBack) {
    $("#group_callback").css("display", "none");
  } else {
    $("#group_callback").html(`${l.translate("Alert")} ${
      loc.groupCallBackSize
    } \
            ${l.translate("covers now")}`);
  }

  $("#group_callback").off();
  $("#group_callback").fastClick((e) => {
    e.stopPropagation();
    groupCallBack(kd, loc.groupCallBackSize);
  });

  $("#reservation_filter_drop").val(l.translate("Show All"));

  $("#reservation_filter_drop").unbind();
  $("#reservation_filter_drop").fastClick((e) => {
    const optionsq = {
      target_id: e.target.id,
      type: "dropdown",
      position: "bottom",
      highlight: $("#reservation_filter_drop").val(),
      adjust: {
        x: 0,
        y: -5,
      },
    };
    component.create(
      optionsq,
      l.toptions(conf.vars.filterTypes),
      (err, value) => {
        $("#reservation_filter_drop").val(value.description);
        kd.localstore.data.filter.name = "";
        kd.localstore.data.filter.time = value.value;
        $("#reservation_filter_search").val("");
        $("#search_box").val("");
        kd.emit("activity.update", {});
      }
    );

    /*
            block.filter('layout_sidebar_content_standard', 'in');
            */
  });

  const flyoutWaitlist = (kd2, target_id, activity_id) => {
    const options = {
      kd: kd2,
      target_id,
      type: "accordion",
      mode: "context_waitlist",
      position: "left",
      adjust: {
        x: -5,
        y: 35,
      },
    };

    data.activity = kd.doc("activity", activity_id)[0];

    component.create(options, data, (err, data2) => {
      switch (data2.value) {
        case "seatparty": {
          if (layout.getIsExpanded()) {
            layout.sidebarMaxClose(conf.vars.interfaceSpeed / 2);
          }
          chart.setSeatParty(data2.activity, "waiting");
          if (
            data.activity.hasOwnProperty("preSelect") &&
            data.activity.preSelect.length > 0
          ) {
            chart.chart.setHighlight(data.activity.preSelect);
            setTimeout(() => {
              kd.emit("chart.update", {});
            }, 300);
          } else {
            kd.emit("directseat", { preference: data.activity.preference });
            tabs.tab(kd, "direct", {
              minimal: true,
              size: data2.activity.size,
            });
          }
          let msg = l.translate("Please select a table to seat this party.");
          if (!func.isTableAvailable()) {
            msg = l.translate(
              "There may not be a table available to seat this party. " +
                "Please cancel this, clear a table, and try again."
            );
          }
          const opt = {
            position: "top",
            block: "header",
            width: "90%",
            seconds: 0,
            h1: msg,
            body: "",
            buttons: [
              {
                description: l.translate("Cancel"),
                value: "close",
              },
            ],
          };
          notification.create(opt, {}, (err2, value) => {
            kd.emit("directseat", { preference: null });
            notification.destroy();
            chart.clearSeatParty();
            chart.chart.clearHighlight();
            kd.emit("chart.update", {});
            tabs.tab(kd, "waiting");
          });

          break;
        }
        case "sendalert": {
          let alerts = 0;
          if (data2.activity.hasOwnProperty("alerts")) {
            alerts = data2.activity.alerts + 1;
          }
          let trigger = [""];
          switch (data2.activity.type) {
            case 1: {
              trigger = ["sms"];
              break;
            }
            case 2: {
              trigger = ["call"];
              break;
            }
            case 4: {
              trigger = ["email"];
              break;
            }
            default: {
              break;
            }
          }
          const proposed = {
            domain: "activity",
            _id: data2.activity._id,
            status: 2,
            trigger,
            statusTimes: {
              added: data2.activity.statusTimes.added,
              alerted: Math.floor(Date.now() / 1000),
            },
            alerts,
          };
          kd.update(proposed)
            .then((result) => {
              switch (data2.activity.type) {
                case 1: {
                  const opt = {
                    position: "top",
                    width: "90%",
                    seconds: 2,
                    color: "#057ED6",
                    h1: l.translate(
                      "Party has been alerted with a text message"
                    ),
                    body: "",
                    buttons: [
                      {
                        description: l.translate("Close"),
                        value: "close",
                      },
                    ],
                  };
                  notification.create(opt, {}, (err3, value) => {
                    notification.destroy();
                  });
                  break;
                }
                case 2: {
                  const opt = {
                    position: "top",
                    width: "90%",
                    seconds: 2,
                    color: "#057ED6",
                    h1: l.translate(
                      "Party has been alerted with an " + "automated phone call"
                    ),
                    body: "",
                    buttons: [
                      {
                        description: l.translate("Close"),
                        value: "close",
                      },
                    ],
                  };
                  notification.create(opt, {}, (err3, value) => {
                    notification.destroy();
                  });
                  break;
                }
                case 3: {
                  const opt = {
                    position: "top",
                    block: "block",
                    width: "90%",
                    seconds: 0,
                    h1: `${l.translate("Please page #")}\
                                    <span class="notification_bold">${
                                      data2.activity.cell
                                    }</span> \
                                    ${l.translate("with your pager system")}`,
                    body: "",
                    buttons: [
                      {
                        description: l.translate("I paged them"),
                        value: "close",
                      },
                    ],
                  };
                  notification.create(opt, {}, (err3, value) => {
                    notification.destroy();
                  });
                  break;
                }
                case 4: {
                  const opt = {
                    position: "top",
                    width: "90%",
                    seconds: 2,
                    color: "#057ED6",
                    h1: "Party has been alerted with an email",
                    body: "",
                    buttons: [
                      {
                        description: l.translate("Ok"),
                        value: "close",
                      },
                    ],
                  };
                  notification.create(opt, {}, (err3, value) => {
                    notification.destroy();
                  });
                  break;
                }
                case 5: {
                  const opt = {
                    position: "top",
                    block: "block",
                    width: "90%",
                    seconds: 0,
                    color: "#057ED6",
                    h1: `${l.translate("Please announce")} \
                                    <span class="notification_bold">${
                                      data2.activity.name
                                    }</span> \
                                    ${l.translate(
                                      "party of"
                                    )} <span class="notification_bold">\
                                    ${data2.activity.size}</span> \
                                    ${l.translate(
                                      "to return to the host stand."
                                    )}`,
                    body: "",
                    buttons: [
                      {
                        description: l.translate("I announced them"),
                        value: "close",
                      },
                    ],
                  };
                  notification.create(opt, {}, (err3, value) => {
                    notification.destroy();
                  });
                  break;
                }
                default: {
                  break;
                }
              }
            })
            .catch((err4) => {
              console.log("err4", err4);
            });
          break;
        }
        case "noshows": {
          const proposed = {
            domain: "activity",
            _id: data2.activity._id,
            status: 6,
          };
          kd.update(proposed)
            .then((result) => {
              const opt = {
                position: "top",
                width: "90%",
                seconds: 2,
                color: "#057ED6",
                h1: l.translate("Party has been moved to the No Shows list."),
                body: "",
                buttons: [
                  {
                    description: l.translate("Close"),
                    value: "close",
                  },
                ],
              };
              notification.create(opt, {}, (err5, value) => {
                notification.destroy();
              });
            })
            .catch((err6) => {
              console.log("err6", err6);
            });
          break;
        }
        case "precheckin": {
          const proposed = {
            domain: "activity",
            _id: data2.activity._id,
            status: 7,
          };
          kd.update(proposed)
            .then((result) => {
              const opt = {
                position: "top",
                width: "90%",
                seconds: 2,
                color: "#057ED6",
                h1: l.translate(
                  "Party has been moved to the Pre Check-In queue."
                ),
                body: "",
                buttons: [
                  {
                    description: l.translate("Close"),
                    value: "close",
                  },
                ],
              };
              notification.create(opt, {}, (err7, value) => {
                notification.destroy();
              });
            })
            .catch((err8) => {
              console.log("err8", err8);
            });
          break;
        }
        case "details": {
          opt = {
            width: "90%",
            type: "addparty",
            subtype: "waitlist",
            mode: "waitlist",
            h1: "Dialog Header",
            body: "This is the body text inside the dialog box",
            buttons: [
              {
                description: "cancel",
                value: "cancel...",
              },
              {
                description: "close",
                value: "close",
              },
              {
                description: "third",
                value: "close",
              },
            ],
          };

          const data = {
            kd,
            location: location.location,
            activity: data2.activity,
          };
          modal.create(opt, data, (err9, value) => {
            modal.destroy();
          });
          break;
        }
        case "moveback": {
          const proposed = {
            domain: "activity",
            _id: data2.activity._id,
            status: 8,
          };
          kd.update(proposed)
            .then((resultW) => {
              const proposedW = {
                domain: "reservation",
                _id: data2.activity.res_id,
                status: 1,
              };
              return kd
                .update(proposedW)
                .then((result2) => {
                  const opt = {
                    position: "top",
                    width: "90%",
                    seconds: 2,
                    color: "#057ED6",
                    h1: l.translate(
                      "Party has been returned to the reservation list."
                    ),
                    body: "",
                    buttons: [
                      {
                        description: l.translate("Close"),
                        value: "close",
                      },
                    ],
                  };
                  notification.create(opt, {}, (err7, value) => {
                    notification.destroy();
                  });
                })
                .catch((err9) => {
                  console.log("err9", err9);
                });
            })
            .catch((err8) => {
              console.log("err8", err8);
            });
          break;
        }
        case "printchit": {
          modal.destroy();
          setTimeout(() => {
            const opt = {
              type: "waitlist",
              location: location.location,
            };
            print.create(opt, data2.activity);
          }, 10);
          break;
        }
        default:
        // nothing
      }
    });
  };

  // 1-2 standard

  let opt = {
    kd,
    targetDiv: "waiting_1-2",
    filter: {
      name: true,
      time: false,
      note: false,
      preference: false,
    },
  };

  let data = {
    type: "waitlist",
    domain: "activity",
    h1: "1-2",
    h2: "10-15m",
    waitSize: 2,
    expand: false,
    single: false,
    group: "1-2",
    refresh: 30,
    height: {
      min: 69 * 2,
    },
    status: {
      min: 1,
      max: 2,
    },
    size: {
      min: 1,
      max: 2,
    },
    waited: {
      min: 0,
      max: 2000,
    },
  };

  block.create(opt, data, (err, target_id, activity_id) => {
    flyoutWaitlist(kd, target_id, activity_id);
  });

  // 3-4 standard

  opt = {
    kd,
    targetDiv: "waiting_3-4",
    filter: {
      name: true,
      time: false,
      note: false,
      preference: false,
    },
  };

  data = {
    type: "waitlist",
    domain: "activity",
    h1: "3-4",
    h2: "10-15m",
    waitSize: 4,
    expand: false,
    single: false,
    group: "3-4",
    refresh: 30,
    height: {
      min: 69 * 2,
    },
    status: {
      min: 1,
      max: 2,
    },
    size: {
      min: 3,
      max: 4,
    },
    waited: {
      min: 0,
      max: 2000,
    },
  };

  block.create(opt, data, (err, target_id, activity_id) => {
    flyoutWaitlist(kd, target_id, activity_id);
  });

  // 5-6 standard

  opt = {
    kd,
    targetDiv: "waiting_5-6",
    filter: {
      name: true,
      time: false,
      note: false,
      preference: false,
    },
  };

  data = {
    type: "waitlist",
    domain: "activity",
    h1: "5-6",
    h2: "10-15m",
    waitSize: 6,
    expand: false,
    single: false,
    group: "5-6",
    refresh: 30,
    height: {
      min: 69 * 2,
    },
    status: {
      min: 1,
      max: 2,
    },
    size: {
      min: 5,
      max: 6,
    },
    waited: {
      min: 0,
      max: 2000,
    },
  };

  block.create(opt, data, (err, target_id, activity_id) => {
    flyoutWaitlist(kd, target_id, activity_id);
  });

  // 7+ standard

  opt = {
    kd,
    targetDiv: "waiting_7",
    filter: {
      name: true,
      time: false,
      note: false,
      preference: false,
    },
  };

  data = {
    type: "waitlist",
    domain: "activity",
    h1: "7+",
    h2: "10-15m",
    waitSize: 8,
    expand: false,
    single: false,
    group: "7+",
    refresh: 30,
    height: {
      min: 69 * 2,
    },
    status: {
      min: 1,
      max: 2,
    },
    size: {
      min: 7,
      max: 500,
    },
    waited: {
      min: 0,
      max: 2000,
    },
  };

  block.create(opt, data, (err, target_id, activity_id) => {
    flyoutWaitlist(kd, target_id, activity_id);
  });

  // longest

  opt = {
    kd,
    targetDiv: "waiting_long",
    filter: {
      name: true,
      time: false,
      note: false,
      preference: false,
    },
  };

  data = {
    type: "waitlist",
    domain: "activity",
    h1: "All Parties",
    h2: "...",
    expand: true,
    single: false,
    group: "all",
    refresh: 30,
    height: {},
    status: {
      min: 1,
      max: 2,
    },
    size: {
      min: 1,
      max: 500,
    },
    waited: {
      min: 0,
      max: 2000,
    },
  };

  block.create(opt, data, (err, target_id, activity_id) => {
    flyoutWaitlist(kd, target_id, activity_id);
  });

  // 1-2 wide by time

  opt = {
    kd,
    targetDiv: "content_wide_col_wait_1-2",
    filter: {
      name: true,
      time: true,
      note: false,
      preference: false,
    },
  };

  data = {
    type: "waitlist",
    domain: "activity",
    h1: "0-10m",
    h2: "...",
    expand: true,
    single: false,
    group: "all",
    refresh: 30,
    height: {},
    status: {
      min: 1,
      max: 2,
    },
    size: {
      min: 1,
      max: 2000,
    },
    waited: {
      min: 0,
      max: 10,
    },
  };

  block.create(opt, data, (err, target_id, activity_id) => {
    flyoutWaitlist(kd, target_id, activity_id);
  });

  // 1-2 wide by party size

  opt = {
    kd,
    targetDiv: "content_wide_col_1-2",
    filter: {
      name: true,
      time: true,
      note: false,
      preference: false,
    },
  };

  data = {
    type: "waitlist",
    domain: "activity",
    h1: "1-2",
    h2: "...",
    waitSize: 2,
    expand: true,
    single: false,
    group: "all",
    refresh: 30,
    height: {},
    status: {
      min: 1,
      max: 2,
    },
    size: {
      min: 1,
      max: 2,
    },
    waited: {
      min: 0,
      max: 2000,
    },
  };

  block.create(opt, data, (err, target_id, activity_id) => {
    flyoutWaitlist(kd, target_id, activity_id);
  });

  // 3-4 wide by time

  opt = {
    kd,
    targetDiv: "content_wide_col_wait_3-4",
    filter: {
      name: true,
      time: true,
      note: false,
      preference: false,
    },
  };

  data = {
    type: "waitlist",
    domain: "activity",
    h1: "11-30m",
    h2: "...",
    expand: true,
    single: false,
    group: "all",
    refresh: 30,
    height: {},
    status: {
      min: 1,
      max: 2,
    },
    size: {
      min: 1,
      max: 2000,
    },
    waited: {
      min: 11,
      max: 30,
    },
  };

  block.create(opt, data, (err, target_id, activity_id) => {
    flyoutWaitlist(kd, target_id, activity_id);
  });

  // 3-4 wide by partysize

  opt = {
    kd,
    targetDiv: "content_wide_col_3-4",
    filter: {
      name: true,
      time: true,
      note: false,
      preference: false,
    },
  };

  data = {
    type: "waitlist",
    domain: "activity",
    h1: "3-4",
    h2: "...",
    waitSize: 4,
    expand: true,
    single: false,
    group: "all",
    refresh: 30,
    height: {},
    status: {
      min: 1,
      max: 2,
    },
    size: {
      min: 3,
      max: 4,
    },
    waited: {
      min: 0,
      max: 2000,
    },
  };

  block.create(opt, data, (err, target_id, activity_id) => {
    flyoutWaitlist(kd, target_id, activity_id);
  });

  // 5-6 wide by waittime

  opt = {
    kd,
    targetDiv: "content_wide_col_wait_5-6",
    filter: {
      name: true,
      time: true,
      note: false,
      preference: false,
    },
  };

  data = {
    type: "waitlist",
    domain: "activity",
    h1: "31-60m",
    h2: "...",
    expand: true,
    single: false,
    group: "all",
    refresh: 30,
    height: {},
    status: {
      min: 1,
      max: 2,
    },
    size: {
      min: 1,
      max: 2000,
    },
    waited: {
      min: 31,
      max: 60,
    },
  };

  block.create(opt, data, (err, target_id, activity_id) => {
    flyoutWaitlist(kd, target_id, activity_id);
  });

  // 5-6 wide by partysize

  opt = {
    kd,
    targetDiv: "content_wide_col_5-6",
    filter: {
      name: true,
      time: true,
      note: false,
      preference: false,
    },
  };

  data = {
    type: "waitlist",
    domain: "activity",
    h1: "5-6",
    h2: "...",
    waitSize: 6,
    expand: true,
    single: false,
    group: "all",
    refresh: 30,
    height: {},
    status: {
      min: 1,
      max: 2,
    },
    size: {
      min: 5,
      max: 6,
    },
    waited: {
      min: 0,
      max: 2000,
    },
  };

  block.create(opt, data, (err, target_id, activity_id) => {
    flyoutWaitlist(kd, target_id, activity_id);
  });

  // 7+ wide by waittime

  opt = {
    kd,
    targetDiv: "content_wide_col_wait_7",
    filter: {
      name: true,
      time: true,
      note: false,
      preference: false,
    },
  };

  data = {
    type: "waitlist",
    domain: "activity",
    h1: "61m+",
    h2: "...",
    expand: true,
    single: false,
    group: "all",
    refresh: 30,
    height: {},
    status: {
      min: 1,
      max: 2,
    },
    size: {
      min: 1,
      max: 2000,
    },
    waited: {
      min: 61,
      max: 2000,
    },
  };

  block.create(opt, data, (err, target_id, activity_id) => {
    flyoutWaitlist(kd, target_id, activity_id);
  });

  // 7+ wide by partysize

  opt = {
    kd,
    targetDiv: "content_wide_col_7",
    filter: {
      name: true,
      time: true,
      note: false,
      preference: false,
    },
  };

  data = {
    type: "waitlist",
    domain: "activity",
    h1: "7+",
    h2: "...",
    waitSize: 7,
    expand: true,
    single: false,
    group: "all",
    refresh: 30,
    height: {},
    status: {
      min: 1,
      max: 2,
    },
    size: {
      min: 7,
      max: 500,
    },
    waited: {
      min: 0,
      max: 2000,
    },
  };

  block.create(opt, data, (err, target_id, activity_id) => {
    flyoutWaitlist(kd, target_id, activity_id);
  });
};

const groupCallBack = (kd, size) => {
  const activity = kd.whereSort(
    "activity",
    (obj) => {
      if (
        obj.hasOwnProperty("status") &&
        obj.status === 1 &&
        obj.hasOwnProperty("type") &&
        (obj.type === 1 || obj.type === 2 || obj.type === 4)
      ) {
        return true;
      }
    },
    (obj1, obj2) => {
      if (obj1.statusTimes.added == obj2.statusTimes.added) {
        return 0;
      }
      if (obj1.statusTimes.added > obj2.statusTimes.added) {
        return 1;
      }
      if (obj1.statusTimes.added < obj2.statusTimes.added) {
        return -1;
      }
    }
  );
  let total = 0;
  let partyCount = 0;
  for (let i = 0; i < activity.length; ++i) {
    if (total + activity[i].size <= size) {
      total += activity[i].size;
      ++partyCount;
      let alerts = 0;
      if (activity[i].hasOwnProperty("alerts")) {
        alerts = activity[i].alerts + 1;
      }
      let trigger = [""];
      switch (activity[0].type) {
        case 1: {
          trigger = ["sms"];
          break;
        }
        case 2: {
          trigger = ["call"];
          break;
        }
        case 4: {
          trigger = ["email"];
          break;
        }
        default: {
          break;
        }
      }
      const proposed = {
        domain: "activity",
        _id: activity[i]._id,
        status: 2,
        trigger,
        statusTimes: {
          added: activity[i].statusTimes.added,
          alerted: Math.floor(Date.now() / 1000),
        },
        alerts,
      };
      kd.update(proposed)
        .then((result) => {
          //
        })
        .catch((err4) => {
          console.log("err4", err4);
        });
    }
  }
  const opt = {
    position: "top",
    width: "90%",
    seconds: 10,
    color: "#057ED6",
    h1: `${partyCount} ${l.translate("parties have been alerted")}`,
    body: l.translate(
      "Please keep in mind group alerting back does not affect " +
        "`Guest Waiting` or `Coaster Pager` methods. Those parties must be alerted " +
        "individually."
    ),
    buttons: [
      {
        description: l.translate("Got it!"),
        value: "close",
      },
    ],
  };
  notification.create(opt, {}, (err3, value) => {
    notification.destroy();
  });
};

module.exports = {
  init,
};



/** WEBPACK FOOTER **
 ** ./src/controllers/waitlist/index.js
 **/